export default __webpack_public_path__ + "static/media/s2s_interview.06926612.png";